// ABOUTME: Goals tab for ChildProfilePage — renders GoalsManager scoped to one child
// ABOUTME: Reuses GoalsManager by passing a single-child array; no logic duplication

import { Box } from '@mui/material';
import GoalsManager from '../GoalsManager';
import { Child } from '../../types/api';

interface GoalsTabProps {
  child: Child;
  familyId: number;
}

export default function GoalsTab({ child, familyId }: GoalsTabProps) {
  return (
    <Box data-testid="goals-tab">
      {/* eslint-disable-next-line react/no-children-prop -- GoalsManager's `children` prop is a domain object array, not React children */}
      <GoalsManager children={[child]} familyId={familyId} familyTimezone={child.familyTimezone} />
    </Box>
  );
}
